// extracted by mini-css-extract-plugin
export var closeButton = "_mk-2";
export var closeButtonIcon = "_mk-3";
export var lightboxContent = "_mk-1";
export var lightboxOverlay = "_mk-0";